import { useTranslation } from "react-i18next"
import { useContextState } from "../../../../../hooks/theme"
import { Box, Grid, Icon, Tooltip, Typography } from "@mui/material"
import { icons } from "../../../../../utils/icons"

const formData: Record<string, string> = {
  keyCode: 'keycode',
  score: "score",
  createTime: "createTime"
}
const useColumnTest = () => {
  const { t } = useTranslation()
  const { colors } = useContextState()
  const styles = {
    text: {
      color: colors.color13,
      fontSize: '12px',
      wordBreak: 'break-word',
      '&.title-table': {
        fontSize: '14px',
        fontWeight: 'bold'
      }
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      '& .w-full': {
        width: '100%'
      }
    },
    text2: {
      fontSize: '12px',
    },
    warning: {
      color: colors.color12
    },
    search: {
      color: '#000',
      opacity: '0.4'
    },
    icons: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      justifyContent: 'end',
      '& .greyColor': {
        color: colors.color10
      }
    },
    grey: {
      color: colors.color10,
      width: '100%'
    },
    containerFlex: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '20px'
    },
    containerSearch: {
      background: colors.color5,
      '& .MuiTypography-root': {
        color: colors.color10
      },
      '& .bold': {
        fontSize: '18px',
        fontWeight: 'bold',
      },
      '& .p-20': {
        padding: '20px'
      },
      '& .px-20': {
        padding: '10px 20px'
      },
      '& .border-t': {
        borderTop: `1px solid ${colors.color10}`
      },
      '& .border-r': {
        borderRight: `1px solid ${colors.color10}`

      }
    }
  }
  return [
    {
      id: 'store',
      label: t('general.tags.store'),
      minWidth: 250,
      renderCell: (params: any) => {
        const row = params.row
        return (
          <Box sx={styles.container}>
            {
              !row.name && !row.address ? <Typography className='w-full' sx={styles.text}>N/A</Typography> : (
                <>
                  <Typography className='w-full' sx={styles.text}>{row.name ?? 'N/A'}</Typography>

                  {row.address && <Typography className='w-full' sx={styles.text}>{t('general.tags.address')}: {row.address ?? 'N/A'} </Typography>}
                </>
              )
            }
          </Box>
        )
      }
    },
    {
      "id": "divisionName",
      "label": t('general.tags.division'),
      minWidth: 120,
    },
    {
      "id": "zoneName",
      "label": t('general.tags.zone'),
      minWidth: 120,
    },
    {
      "id": "className",
      "label": t('general.tags.class'),
      minWidth: 120,
    },
    {
      "id": "state",
      "label": t('dashboard.data.state'),
      minWidth: 120,
    },
    {
      "id": "country",
      "label": t('dashboard.data.city'),
      minWidth: 120,
    },
    {
      "id": "zipCodeId",
      "label": t('general.tags.zipCode'),
      minWidth: 120,
    },
    {
      "id": "companyName",
      "label": t('general.tags.company'),
      minWidth: 120,
    },
    {
      "id": "userManageName",
      "label": t('general.tags.user'),
      minWidth: 120,
    },
    {
      "id": "id",
      "label": 'Registro',
      minWidth: 120,
      renderCell: (params: any) => {
        return <Typography sx={styles.grey} variant='body2'>{params.current?.toString()?.includes('tmp-id') ? 'Nuevo' : 'Existe'}</Typography>
      }
    },
    {
      id: 'Errores',
      label: "",
      minWidth: 50,
      renderCell: (params: any) => {
        const row = params.row

        return (
          <Box sx={styles.icons}>
            {params.current && (
              <Tooltip
                componentsProps={{
                  tooltip: {
                    sx: {
                      '&.MuiTooltip-tooltip.MuiTooltip-tooltip': {
                        backgroundColor: `${colors.color5}`,
                        borderRadius: '8px',
                        overflow: 'hidden',
                        marginRight: '20px',
                        padding: '20px',
                        boxShadow: `0px 0px 2px ${colors.color10}`
                      }
                    }
                  }
                }}
                title={<Box sx={styles.containerFlex}>
                  {params.current?.split(',')?.map((item: string) => <Typography sx={styles.grey} variant='body2'>{item}</Typography>)}
                </Box>}
                children={<Icon sx={styles.warning}>{icons('warningFull')}</Icon>}
              />
            )}

            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    '&.MuiTooltip-tooltip.MuiTooltip-tooltip': {
                      backgroundColor: `${colors.color5}`,
                      minWidth: '280px',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      marginRight: '20px',
                      padding: '0',
                      boxShadow: `0px 0px 2px ${colors.color10}`
                    }
                  }
                }
              }}
              title={
                <Box sx={styles.containerSearch}>
                  <Box className="p-20">
                    <Typography className="bold">ID: {row.keyCode || 'N/A'}</Typography>

                    {!!row.email && <Typography variant="body2">{t('general.tags.email2')}: {row.email}</Typography>}

                    {!!row.phone && <Typography variant="body2">{t('general.tags.phone')}: {row.phone}</Typography>}
                  </Box>

                  <Grid container className="border-t">
                    <Grid item xs={6} className="border-r px-20">
                      <Typography>{t('general.tags.longitude')}</Typography>

                      <Typography>{row.longitude || 'N/A'}</Typography>
                    </Grid>

                    <Grid item xs={6} className="px-20">
                      <Typography>{t('general.tags.latitude')}</Typography>

                      <Typography>{row.latitude || 'N/A'}</Typography>
                    </Grid>
                  </Grid>
                </Box>
              }
              children={<Icon sx={styles.search}>{icons('search')}</Icon>}
            />
          </Box>
        )
      }
    },
  ]

}
export { formData, useColumnTest }